import { render, staticRenderFns } from "./scope135.vue?vue&type=template&id=8dd7a314&scoped=true"
import script from "./scope135.vue?vue&type=script&lang=js"
export * from "./scope135.vue?vue&type=script&lang=js"
import style0 from "./scope135.vue?vue&type=style&index=0&id=8dd7a314&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd7a314",
  null
  
)

export default component.exports